import { Skeleton } from '@mui/material';
import styled from 'styled-components';

export const DashboardLoading = () => {
  return (
    <StyledLoading>
      <div>
        <Skeleton
          animation="wave"
          style={{
            borderRadius: '20px',
            height: '50px',
            width: '240px'
          }}
        />
        <Skeleton
          animation="wave"
          style={{
            borderRadius: '20px',
            height: '50px',
            width: '240px'
          }}
        />
      </div>
      <div className="second-row">
        <Skeleton
          animation="wave"
          style={{
            borderRadius: '20px',
            height: '50px',
            width: '400px'
          }}
        />
        <Skeleton
          animation="wave"
          style={{
            borderRadius: '20px',
            height: '50px',
            width: '400px'
          }}
        />
        <Skeleton
          animation="wave"
          style={{
            borderRadius: '20px',
            height: '100px',
            width: '250px'
          }}
        />
      </div>
    </StyledLoading>
  );
};

const StyledLoading = styled.div`
  display: none;
  place-items: center;
  width: 100%;
  height: 80vh;
  .second-row {
    display: grid;
    place-items: center;
  }
  @media screen and (min-width: 1024px) {
    display: grid;
  }
`;
